/* mc-vpick.js — look at the card, then choose it.

   The variants on this shop are printed cards and the text lives inside
   the photograph. The old picker listed them as "B012-GB-01 · KM 79",
   which asks somebody to pick a sentence they cannot read, by a
   warehouse code that means nothing to them.

   Now they are tiles. Tapping one opens it large enough to read, with a
   button that commits — reading and choosing are separate acts, and a
   customer must be able to do the first without accidentally doing the
   second.

   Selection itself is not implemented here. The tiles carry the same
   [data-bh-pack] hook bh-cod-form.js already listens for, so price,
   total and the hidden variant field keep working through one
   implementation. This file only opens the viewer and, on confirm,
   forwards the click to the tile. */
(function () {
  'use strict';

  var pick = document.querySelector('[data-mc-vpick]');
  if (!pick) return;

  var lb = null, current = null;

  /* The tile interceptor below swallows every click on a tile so it
     opens the viewer instead of selecting. That includes the click the
     viewer itself fires when the customer confirms — so confirming did
     nothing at all. This flag lets exactly that one click through. */
  var committing = false;

  function build() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'mc-lb mc-vlb';
    lb.hidden = true;
    /* The bar is a SIBLING of the stage, not a child of it.

       It was inside, and the CSS is written for .mc-vlb being a two-row
       grid — picture, then bar. With the bar one level too deep the
       second row was empty (measured: grid-template-rows "800px 0px")
       and the bar fell into the stage's horizontal flex row instead,
       rendering as a 169px column floating beside the card at
       mid-height. On a phone it landed exactly on top of the "next"
       arrow and swallowed it, so aiming at next committed the card on
       screen — the wrong one.

       One level of nesting. Everything the shop reported came out of
       it. */
    lb.innerHTML =
      '<div class="mc-lb__scrim" data-close></div>' +
      '<div class="mc-lb__stage" role="dialog" aria-modal="true">' +
        '<button class="mc-lb__x" type="button" data-close aria-label="Zatvori">&times;</button>' +
        '<button class="mc-lb__nav mc-lb__nav--prev" type="button" data-step="-1" aria-label="Prethodna">&lsaquo;</button>' +
        '<div class="mc-lb__frame"></div>' +
        '<button class="mc-lb__nav mc-lb__nav--next" type="button" data-step="1" aria-label="Sljedeća">&rsaquo;</button>' +
      '</div>' +
      '<div class="mc-vlb__bar">' +
        '<span class="mc-vlb__pos"></span>' +
        '<button class="bh-btn bh-btn--order mc-vlb__ok" type="button" data-choose></button>' +
      '</div>';
    document.body.appendChild(lb);

    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return close();
      var step = e.target.closest('[data-step]');
      if (step) return show(current + parseInt(step.dataset.step, 10));
      if (e.target.closest('[data-choose]')) {
        /* Commit by clicking the tile itself, so selection stays in one
           place: bh-cod-form.js is listening there and owns the price,
           the total and the hidden variant field. */
        committing = true;
        try { tiles()[current].click(); } finally { committing = false; }
        /* aria-checked is written by Liquid at render and nothing
           repaints it afterwards, so the tick would stay on whichever
           tile loaded selected. */
        tiles().forEach(function (t, i) {
          t.setAttribute('aria-checked', i === current ? 'true' : 'false');
        });
        close();
      }
    });
    return lb;
  }

  function tiles() {
    return [].slice.call(pick.querySelectorAll('.mc-vpick__tile'));
  }

  function show(i) {
    var list = tiles();
    if (!list.length) return;
    if (i < 0) i = list.length - 1;
    if (i >= list.length) i = 0;
    current = i;

    var t = list[i];
    var frame = lb.querySelector('.mc-lb__frame');
    frame.innerHTML = '';
    var img = document.createElement('img');
    img.className = 'mc-lb__img';
    img.src = t.dataset.full || t.querySelector('img').currentSrc;
    img.alt = '';
    frame.appendChild(img);

    lb.querySelector('.mc-vlb__pos').textContent = (i + 1) + ' / ' + list.length;

    var ok = lb.querySelector('.mc-vlb__ok');
    ok.textContent = (pick.dataset.chooseLabel || 'Izaberi ovu');
    /* A sold-out card can be read but not ordered. */
    ok.disabled = t.disabled;

    var many = list.length > 1;
    lb.querySelectorAll('.mc-lb__nav').forEach(function (b) { b.hidden = !many; });
  }

  function open(i) {
    build();
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    show(i);
    lb.querySelector('[data-close]').focus();
  }

  function close() {
    if (!lb) return;
    lb.hidden = true;
    document.body.style.overflow = '';
    /* Do not leave a 1600px card decoding behind a closed overlay. */
    lb.querySelector('.mc-lb__frame').innerHTML = '';
  }

  /* The tile opens the viewer rather than selecting outright. Choosing a
     card you have not read is the thing this whole picker exists to
     stop. */
  pick.addEventListener('click', function (e) {
    if (committing) return;          /* the confirm click passes through */
    var t = e.target.closest('.mc-vpick__tile');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    open(tiles().indexOf(t));
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
  });

  /* Swipe between cards inside the viewer. Horizontal intent only — a
     vertical drag is somebody trying to scroll. */
  var x0 = null, y0 = null;
  document.addEventListener('touchstart', function (e) {
    if (!lb || lb.hidden) return;
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!lb || lb.hidden || x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    var dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
    x0 = null; y0 = null;
  }, { passive: true });
})();
